(function () {
  var PINIT_SRC = 'https://assets.pinterest.com/js/pinit.js';

  function buildWidgets() {
    if (window.PinUtils && typeof window.PinUtils.build === 'function') {
      window.PinUtils.build();
      return;
    }
    if (typeof window.parsePinBtns === 'function') {
      window.parsePinBtns();
    }
  }

  function onPinitReady() {
    buildWidgets();
  }

  if (document.querySelector('script[src*="pinit.js"]')) {
    onPinitReady();
    return;
  }

  var script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = PINIT_SRC;
  script.onload = onPinitReady;
  document.body.appendChild(script);
})();
